import * as React from "react";
import type { Observation } from "@/data/types";

interface Props {
  observation: Observation;
  index: number;
}

export const ObservationCard: React.FC<Props> = ({ observation, index }) => {
  const num = String(index + 1).padStart(2, "0");
  return (
    <li
      className="grid grid-cols-[auto_1fr] gap-6 border-t border-charcoal/10 py-8 md:gap-10 md:py-10"
      data-testid={`observation-${index}`}
    >
      <span className="font-serif text-3xl leading-none text-brass md:text-4xl">
        {num}
      </span>
      <div>
        <h3 className="font-serif text-xl text-charcoal md:text-2xl">
          {observation.title}
        </h3>
        <p className="mt-3 max-w-prose text-base leading-relaxed text-charcoal-soft md:text-lg">
          {observation.observation}
        </p>
        {observation.evidence && (
          <p className="mt-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.16em] text-charcoal-muted">
            <span className="h-px w-5 bg-brass" />
            {observation.evidence}
          </p>
        )}
      </div>
    </li>
  );
};
